'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getDeviceInformation;
var PHONE = 767;
var DESKTOP = 1200;
var userAgent = window.navigator.userAgent.toLowerCase();

var find = function find(needle) {
  return userAgent.indexOf(needle) !== -1;
};

var isWindows = function isWindows() {
  return find('windows');
};

var isIphone = function isIphone() {
  return !isWindows() && find('iphone');
};

var isIpod = function isIpod() {
  return find('ipod');
};

var isIpad = function isIpad() {
  return find('ipad');
};

// const isIos = () => {
//   return isIphone() || isIpod() || isIpad();
// };

var isAndroid = function isAndroid() {
  return !isWindows() && find('android');
};

var isAndroidPhone = function isAndroidPhone() {
  return isAndroid() && find('mobile');
};

var isAndroidTablet = function isAndroidTablet() {
  return isAndroid() && !find('mobile');
};

var isBlackberry = function isBlackberry() {
  return find('blackberry') || find('bb10') || find('rim');
};

var isBlackberryPhone = function isBlackberryPhone() {
  return isBlackberry() && !find('tablet');
};

var isBlackberryTablet = function isBlackberryTablet() {
  return isBlackberry() && find('tablet');
};

var isWindowsPhone = function isWindowsPhone() {
  return isWindows() && find('phone');
};

var isWindowsTablet = function isWindowsTablet() {
  return isWindows() && find('touch') && !isWindowsPhone();
};

var isFxos = function isFxos() {
  return (find('(mobile;') || find('(tablet;')) && find('; rv:');
};

var isFxosPhone = function isFxosPhone() {
  return isFxos() && find('mobile');
};

var isFxosTablet = function isFxosTablet() {
  return isFxos() && find('tablet');
};

var isMeego = function isMeego() {
  return find('meego');
};

// const isCordova = () => {
//   return window.cordova && location.protocol === 'file:';
// };

// const isNodeWebkit = () => {
//   return typeof window.process === 'object';
// };

var isUIPhone = function isUIPhone() {
  return window.innerWidth <= PHONE;
};

var isUITablet = function isUITablet() {
  return window.innerWidth > PHONE && window.innerWidth <= DESKTOP;
};

var isUIDesktop = function isUIDesktop() {
  return window.innerWidth >= DESKTOP;
};

var isPhone = function isPhone() {
  return isUIPhone() || isAndroidPhone() || isIphone() || isIpod() || isWindowsPhone() || isBlackberryPhone() || isFxosPhone() || isMeego();
};

var isTablet = function isTablet() {
  return isUITablet() || isIpad() || isAndroidTablet() || isBlackberryTablet() || isWindowsTablet() || isFxosTablet();
};

var isDesktop = function isDesktop() {
  return isUIDesktop() || !isTablet() && !isPhone();
};

var isTelevision = function isTelevision() {
  var television = ['googletv', 'viera', 'smarttv', 'internet.tv', 'netcast', 'nettv', 'appletv', 'boxee', 'kylo', 'roku', 'dlnadoc', 'roku', 'pov_tv', 'hbbtv', 'ce-html'];

  return !!television.find(function (tv) {
    return find(tv);
  });
};

var isPortrait = function isPortrait() {
  return window.innerHeight / window.innerWidth > 1;
};

var isLandscape = function isLandscape() {
  return window.innerHeight / window.innerWidth < 1;
};

var getWindowWidth = function getWindowWidth() {
  return window.innerWidth;
};

var getWindowHeight = function getWindowHeight() {
  return window.innerHeight;
};

function getDeviceInformation() {
  return {
    isPortrait: isPortrait(),
    isLandscape: isLandscape(),
    isPhone: isPhone(),
    isTablet: isTablet(),
    isDesktop: isDesktop(),
    isTelevision: isTelevision(),
    width: getWindowWidth(),
    height: getWindowHeight()
  };
}